"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleTypeSchema = void 0;
const zod_1 = require("zod");
exports.ArticleTypeSchema = zod_1.z.enum(['leitung', 'link', 'kette', 'ae', 'ia', 'zugentlastung', 'verpackung', 'konfektionierung', 'fuehrungsrinne', 'montageSet', 'montBes', 'espool', 'zubehoer']);
exports.default = exports.ArticleTypeSchema;
//# sourceMappingURL=ArticleTypeSchema.js.map